export class LoginViewModel {
    constructor(parent, options) {
        BaseViewModel.call(this);
        var self = this;
        self.parent = parent;
        self.options = options;
        self.isLoading = ko.observable(false);
        self.isVisible = ko.observable(true);


        self.UserName = ko.observable("");
        self.Password = ko.observable("");
        self.passwordResetSuccess = ko.observable(false);

        self.isShop = ko.computed(function () {
            return app.orderType === "Shop";
        })
        self.headText = ko.observable('Jetzt bestellen? Los geht\'s!...');
        self.shouldValidate = ko.observable(false);
        self.errorGroup = ko.validation.group(self, { deep: false });
        self.errorMessages = ko.observableArray();
        self.errors = ko.pureComputed(function () {

            var filtered = self.errorGroup.filter(function (item) {
                var message = item.error();
                if (!item.isModified()) {
                    return null;
                }
                return message;
            });

            var test = _.map(filtered, function (item) { return item.error(); });
            _.each(self.errorMessages(), function (item) { test.push(item) });
            var messages = _.uniq(test);
            return messages;
        });

        self.showErrors = ko.computed(function () {
            return self.errorGroup.isAnyMessageShown();
        });
        self.hasErrors = ko.computed(function () {
            return self.errors().length > 0;
        });
        self.validate = function () {
            self.errorGroup();
            self.errorGroup.showAllMessages();

            if (self.hasErrors()) {
                return false;
            }
            return true;
        };

        self.login = function () {
            self.Validate_Password(true);
            self.isLoading(true);
            setTimeout(function () {

                if (!self.validate()) {
                    self.isLoading(false);
                    return;
                }


                var data = self.toJS();
                data.UserName = data.UserName?.trim();
                data.Password = data.Password?.trim();
                $.postJSON('/api/account/anmelden', {
                    ViewModelMode: 0,
                    Login: data

                }).done(function (result) {

                    try {
                        self.errorMessages.removeAll();
                        if (_.isUndefined(result.Success)) {
                            // check for validation messages if Success is not set

                        } else if (result.Success) {
                            Cookies.remove('.heizoel24.guestorder');
                            if (_.isString(result.RedirectUrl) && result.RedirectUrl.length > 0) {
                                window.location = result.RedirectUrl;
                            }
                            else {
                                // redirect or reload
                                if (_.isString(app.redirectUrl)) {
                                    window.location = app.redirectUrl;
                                } else {
                                    window.location.reload(true);
                                }
                            }
                            return;
                        } else {
                            // get error message
                            switch (result.Reason) {
                                case "PasswordIncorrect":
                                    self.Password.setError("<strong>Das eingegebenen Passwort ist nicht korrekt.</strong><br/>Bitte korrigieren Sie die Schreibweise oder lassen Sie sich ein <span class='switch-link' data-bind='click: resetPassword'>neues Passwort zusenden.</span>");
                                    self.Password.isModified(true);
                                    break;
                                case "EmailUnknown":

                                    self.UserName.setError("<strong>Diese E-Mail-Adresse ist uns nicht bekannt.</strong><br/>Bitte korrigieren Sie die Schreibweise oder eröffnen Sie ein <span class='switch-link' data-bind='click: register'>neues HeizOel24-Konto.</span>");
                                    self.UserName.isModified(true);
                                    break;
                                default:
                                    self.UserName.setError("Anmeldung fehlgeschlagen");
                                    self.UserName.isModified(true);
                                    self.Password.setError("Anmeldung fehlgeschlagen");
                                    self.Password.isModified(true);
                                    break;
                            }
                            self.validate();
                        }
                        self.isLoading(false);
                    } catch (exc) {
                        self.isLoading(false);
                        return;
                    }


                }).fail(function (result) {

                    try {
                        self.errorMessages.removeAll();
                        if (result.status === 403) {
                            var message = result.responseText.replace(/[\\"]/g, "") || result.responseJSON;
                            if (typeof message !== "string") {
                                message = "Die Anmeldung wurde abgelehnt. Bitte versuchen Sie es später erneut.";
                            }
                            self.errorMessages.push(message);
                        } else {
                            var message = "Es ist ein unbekannter Fehler aufgetreten. Bitte melden Sie sich beim Kundensupport. Statuscode: " + result.status;
                            self.errorMessages.push(message);
                        }
                    } finally {
                        self.isLoading(false);
                    }
                });
            }, 100);
            return false;

        };
        self.resetPassword = function () {
            self.Validate_Password(false);
            if (self.UserName.isValid()) {
                var userName = self.UserName();
                if (_.isString(userName) && userName.length > 0) {
                    var dialog = app.rootViewModel().dialog;
                    dialog.styleClasses('info-modal modal-480');
                    dialog.show('reset-password', self);

                }
            } else {
                self.validate();
            }
        };
        self.confirmPasswordReset = function () {
            // TODO: validate UserName
            self.passwordResetSuccess(false);
            self.Validate_Password(false);
            var userName = self.UserName();
            if (_.isString(userName) && userName.length > 0) {
                // check if userName is a valid e-mail
                var data = { 'UserName': userName };
                $.postJSON('/api/account/password-reset', data)
                    .done(function (result) {
                        // check result
                        if (result.Success) {
                            self.passwordResetSuccess(true);

                        } else {
                            self.UserName.setError("<strong>Diese E-Mail-Adresse ist uns nicht bekannt.</strong><br/>Bitte kontrollieren Sie Ihre Eingabe.");
                            self.UserName.isModified(true);
                        }
                    })
                    .fail(function (result) {
                        if (result.status === 400) {
                            self.UserName.setError("<strong>Diese E-Mail-Adresse ist uns nicht bekannt.</strong><br/>Bitte kontrollieren Sie Ihre Eingabe.");
                            self.UserName.isModified(true);
                        }
                        else if (result.status === 403) {
                            var txt = "";
                            try {
                                txt = JSON.parse(result.responseText)
                            } catch (exc) {
                                txt = "<strong>Serveranfrage fehlgeschlagen</strong>Der Server hat Ihre Anfrage abgelehnt. Bitte versuchen Sie es später erneut."
                            }
                            self.UserName.setError(txt);
                            self.UserName.isModified(true);
                        } else {
                            self.UserName.setError("<strong>Serveranfrage fehlgeschlagen</strong><br/>Bitte überprüfen Sie die Schreibweise oder probieren Sie es später erneut.");
                            self.UserName.isModified(true);
                        }
                    });
            }
        };
        self.register = function () {
            // transfer values to registration form

            self.parent.openRegistration();
        };


        // initialize validation 
        self.Validate_Password = ko.observable(true);
        self.UserName = self.UserName.extend({
            required: {
                message: 'Bitte hinterlegen Sie Ihre E-Mail-Adresse.'
            }
        });
        self.Password = self.Password.extend({
            required: {
                message: 'Bitte geben Sie ein Passwort ein.',
                onlyIf: self.Validate_Password
            }
        });


        self.ignore.push('errors');
        self.ignore.push('Validate_Password');
        self.ignore.push('hasErrors');
        self.ignore.push('showErrors');
        self.ignore.push('shouldValidate');

        self.ignore.push('login');
        self.ignore.push('resetPassword');
        self.ignore.push('register');

        self.ignore.push('options');
        self.ignore.push('isLoading');
        self.ignore.push('isVisible');

        window.document.title = 'Anmelden';

        self.init = function () {
            if (app.orderType === "Shop") {
                self.headText('meX bestellen? Los geht\'s!...');
            } else {
                self.headText('Jetzt bestellen? Los geht\'s!...');
            }
        };

        self.init();
    }
}
ExtendViewModel(LoginViewModel, BaseViewModel);